"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3941],{

/***/ 25531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/custom-carousel/CustomCarousel.module.scss.js


var css_248z = ".CustomCarousel-module_main__4Xe9U {\n  position: relative;\n}\n\n.CustomCarousel-module_row__YVtIr {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  overflow-x: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  overflow-y: scroll;\n  scroll-behavior: smooth;\n  -webkit-transition: all 3000ms ease-in-out;\n  -moz-transition: all 3000ms ease-in-out;\n  -ms-transition: all 3000ms ease-in-out;\n  -o-transition: all 3000ms ease-in-out;\n  transition: all 3000ms ease-in-out;\n}\n\n.CustomCarousel-module_row__YVtIr > div:nth-last-child(1) div {\n  margin-right: 0;\n}\n\n.CustomCarousel-module_next__9OTzF {\n  position: absolute;\n  top: 40%;\n  right: 0;\n  z-index: 5;\n  cursor: pointer;\n  overflow: hidden;\n  border: none;\n  outline: none;\n}\n.CustomCarousel-module_next__9OTzF svg {\n  position: absolute;\n  margin: auto;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 6px;\n  height: 16px;\n}\n\n.CustomCarousel-module_prev__DvC9i {\n  position: absolute;\n  top: 40%;\n  left: 0;\n  z-index: 5;\n  cursor: pointer;\n  overflow: hidden;\n  border: none;\n  outline: none;\n}\n.CustomCarousel-module_prev__DvC9i svg {\n  position: absolute;\n  margin: auto;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 6px;\n  height: 16px;\n}\n\n.CustomCarousel-module_next__9OTzF::before,\n.CustomCarousel-module_prev__DvC9i::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.CustomCarousel-module_row__YVtIr::-webkit-scrollbar {\n  display: none;\n}\n\n.CustomCarousel-module_prevNextWrapper__Q707t {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n}\n\n.CustomCarousel-module_dots__zKEeU {\n  max-width: max-content;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.CustomCarousel-module_dots__zKEeU .CustomCarousel-module_dot__sMsW4 {\n  background-color: #c4c4c4;\n  border-radius: 50%;\n  display: inline-block;\n  cursor: pointer;\n}\n.CustomCarousel-module_dots__zKEeU .CustomCarousel-module_dot__sMsW4.CustomCarousel-module_activeDot__HaSFV {\n  background-color: var(--primary-color);\n}\n\n@media (max-width: 991px) {\n  .CustomCarousel-module_dots__zKEeU {\n    margin: 0 auto 0;\n  }\n  .CustomCarousel-module_dots__zKEeU .CustomCarousel-module_dot__sMsW4 {\n    width: 9px;\n    height: 9px;\n    margin: 0 3px;\n  }\n}\n@media (min-width: 992px) {\n  .CustomCarousel-module_row__YVtIr {\n    align-items: center;\n  }\n  .CustomCarousel-module_dots__zKEeU {\n    margin: 30px auto 0;\n  }\n  .CustomCarousel-module_dots__zKEeU .CustomCarousel-module_dot__sMsW4 {\n    width: 12px;\n    height: 12px;\n    margin: 0 5px;\n  }\n}";
var Styles = {"main":"CustomCarousel-module_main__4Xe9U","row":"CustomCarousel-module_row__YVtIr","next":"CustomCarousel-module_next__9OTzF","prev":"CustomCarousel-module_prev__DvC9i","prevNextWrapper":"CustomCarousel-module_prevNextWrapper__Q707t","dots":"CustomCarousel-module_dots__zKEeU","dot":"CustomCarousel-module_dot__sMsW4","activeDot":"CustomCarousel-module_activeDot__HaSFV"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=CustomCarousel.module.scss.js.map

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/hooks/useIntersect.js
var useIntersect = __webpack_require__(86369);
;// CONCATENATED MODULE: ../core/dist/components/custom-carousel/CustomCarousel.js





const CustomCarousel = ({ children, containerClass, rowClass, itemClass, activeClass, nextArrowClass, prvArrowClass, prevNextBtnsClass, scrollBy, items, fallback, prvArrow, nextArrow, length, dotsClass, activeDotClass }) => {
    const elmRef = (0,react.useRef)(null);
    const itemRef = (0,react.useRef)(null);
    const [scrollByitemWidth, setScrollByitemWidth] = (0,react.useState)(0);
    const [isLastItem, setIsLastItem] = (0,react.useState)(false);
    const [isFirstItem, setIsFirstItem] = (0,react.useState)(false);
    const [currentItem, setCurrentItem] = (0,react.useState)(0);
    const [isMouseOver, setIsMouseOver] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (scrollByitemWidth) {
            scrollHorizontal(scrollByitemWidth);
        }
    }, [scrollByitemWidth, currentItem]);
    const { entry: lastInterSectionObj, setNode: lastElmRef } = (0,useIntersect/* useIntersect */.U)({
        // rootMargin: getHeightByViewPort(0),
        threshold: 1
    });
    (0,react.useEffect)(() => {
        if ((lastInterSectionObj === null || lastInterSectionObj === void 0 ? void 0 : lastInterSectionObj.intersectionRatio) === 1) {
            setIsLastItem(true);
        }
        else {
            setIsLastItem(false);
        }
        return () => {
            setIsLastItem(false);
        };
    }, [lastInterSectionObj, length]);
    const { entry: firstInterSectionObj, setNode: firstElmRef } = (0,useIntersect/* useIntersect */.U)({
        // rootMargin: getHeightByViewPort(0),
        threshold: 1
    });
    (0,react.useEffect)(() => {
        if ((firstInterSectionObj === null || firstInterSectionObj === void 0 ? void 0 : firstInterSectionObj.intersectionRatio) === 1) {
            setIsFirstItem(true);
        }
        else {
            // if (items?.length === 1) {
            //     setIsLastItem (false)
            // }
            setIsFirstItem(false);
        }
        return () => {
            setIsFirstItem(false);
        };
    }, [firstInterSectionObj, length]);
    const scrollHorizontal = (scrollOffset) => {
        elmRef.current.scrollLeft += scrollOffset;
        setScrollByitemWidth(0);
    };
    const handlePrvArrow = (event) => {
        if (isFirstItem) {
            setScrollByitemWidth(itemRef.current.offsetWidth * length);
            setCurrentItem(length - 1);
        }
        else {
            setScrollByitemWidth(itemRef.current.offsetWidth * scrollBy * -1);
            setCurrentItem(currentItem - 1);
        }
        event.target.setAttribute("disabled", true);
        setTimeout(function () {
            event.target.removeAttribute("disabled");
        }, 800);
    };
    const handleNextArrow = (event) => {
        if (isLastItem) {
            setScrollByitemWidth(itemRef.current.offsetWidth * length * -1);
            setCurrentItem(0);
        }
        else {
            setScrollByitemWidth(itemRef.current.offsetWidth * scrollBy);
            setCurrentItem(currentItem + 1);
        }
        event.target.setAttribute("disabled", true);
        setTimeout(function () {
            event.target.removeAttribute("disabled");
        }, 800);
    };
    const prevCountRef = (0,react.useRef)();
    (0,react.useEffect)(() => {
        prevCountRef.current = currentItem;
    }, [currentItem]);
    const prevCount = prevCountRef.current;
    (0,react.useEffect)(() => {
        if (itemRef.current)
            if (currentItem > prevCount) {
                setScrollByitemWidth(itemRef.current.offsetWidth * (currentItem - prevCount));
            }
            else {
                setScrollByitemWidth(itemRef.current.offsetWidth * (prevCount - currentItem) * -1);
            }
    }, [currentItem, itemRef]);
    const onClickDotHandleItems = (targetItem) => {
        setCurrentItem(targetItem);
    };
    (0,react.useEffect)(() => {
        let interval;
        if (!isMouseOver) {
            interval = setInterval(() => {
                if (currentItem < length - 1) {
                    setCurrentItem((count) => count + 1);
                }
                else {
                    setCurrentItem((count) => count - (length - 1));
                }
            }, 5000);
        }
        else {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval);
        };
    }, [currentItem, isMouseOver]);
    const onMouseEnterStopInterval = () => {
        setIsMouseOver(true);
    };
    const onMouseLeaveStartInterval = () => {
        setIsMouseOver(false);
    };
    return (react.createElement("div", { className: classnames_default()(Styles.main, containerClass) },
        ((items === null || items === void 0 ? void 0 : items.length) || children) && (react.createElement(react.Fragment, null,
            react.createElement("div", { ref: elmRef, className: classnames_default()(Styles.row, rowClass) }, items === null || items === void 0 ? void 0 :
                items.map((item, index) => (react.createElement("div", { key: index, ref: index === 0 ? firstElmRef : index === items.length - 1 ? lastElmRef : itemRef, className: classnames_default()(Styles.item, itemClass, currentItem === index && activeClass), onMouseEnter: onMouseEnterStopInterval, onMouseLeave: onMouseLeaveStartInterval }, item))),
                children),
            prvArrow && items && items.length > 1 ? (react.createElement("button", { className: classnames_default()(Styles.prev, prvArrowClass), onClick: (e) => handlePrvArrow(e) }, prvArrow)) : (react.createElement(react.Fragment, null)),
            nextArrow && items && items.length > 1 ? (react.createElement("button", { className: classnames_default()(Styles.next, nextArrowClass), onClick: (e) => handleNextArrow(e) }, nextArrow)) : (react.createElement(react.Fragment, null)),
            items && items.length > 1 ? (react.createElement("div", { className: classnames_default()(Styles.dots, dotsClass) }, items === null || items === void 0 ? void 0 : items.map((data, index) => (react.createElement("span", { key: index, className: classnames_default()(Styles.dot, currentItem === index && Styles.activeDot, currentItem === index && activeDotClass), onClick: () => onClickDotHandleItems(index) }))))) : (react.createElement(react.Fragment, null)))),
        fallback));
};


//# sourceMappingURL=CustomCarousel.js.map


/***/ }),

/***/ 46168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ QuickFilterPill; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/quick-filter-pill/QuickFilterPill.module.scss.js


var css_248z = ".QuickFilterPill-module_container__f0pwH {\n  display: flex;\n  align-items: center;\n  border: 2px solid #e9e9e9;\n  background-color: #ffffff;\n  white-space: nowrap;\n  color: #202124;\n  cursor: pointer;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_selected__fzeZK {\n  background-color: #f0f4fc;\n  font-family: var(--font-medium);\n  border-color: #1053ff;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_selected__fzeZK .QuickFilterPill-module_text__co2Ao {\n  color: #1053ff;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_loading__iK-d9 {\n  padding: 0 !important;\n  border: 2px solid transparent !important;\n}\n.QuickFilterPill-module_container__f0pwH .QuickFilterPill-module_prefix__67LJS,\n.QuickFilterPill-module_container__f0pwH .QuickFilterPill-module_suffix__yDauR {\n  display: flex;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_mobile__lK8eO {\n  border-radius: 15px;\n  font-size: 0.75rem;\n  letter-spacing: -0.0075rem;\n  height: 30px;\n  padding: 8px 16px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_mobile__lK8eO .QuickFilterPill-module_prefix__67LJS {\n  padding-right: 6px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_mobile__lK8eO .QuickFilterPill-module_suffix__yDauR {\n  padding-left: 6px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_desktop__kbGi0 {\n  border-radius: 20.5px;\n  font-size: 0.8125rem;\n  letter-spacing: -0.00875rem;\n  height: 38px;\n  padding: 3px 10px 0px 10px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_desktop__kbGi0 .QuickFilterPill-module_prefix__67LJS {\n  padding-right: 8px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_desktop__kbGi0 .QuickFilterPill-module_suffix__yDauR {\n  padding-left: 8px;\n}";
var QuickFilterPillStyles = {"container":"QuickFilterPill-module_container__f0pwH","selected":"QuickFilterPill-module_selected__fzeZK","text":"QuickFilterPill-module_text__co2Ao","loading":"QuickFilterPill-module_loading__iK-d9","prefix":"QuickFilterPill-module_prefix__67LJS","suffix":"QuickFilterPill-module_suffix__yDauR","mobile":"QuickFilterPill-module_mobile__lK8eO","desktop":"QuickFilterPill-module_desktop__kbGi0"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=QuickFilterPill.module.scss.js.map

// EXTERNAL MODULE: ../core/dist/components/skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(71155);
;// CONCATENATED MODULE: ../core/dist/components/quick-filter-pill/QuickFilterPill.js





function QuickFilterPill({ text, prefix, suffix, isMobile, className, selectedClassName, prefixClassName, suffixClassName, isSelected = false, onSelected, onDeselected, data, isLoading }) {
    const _onSelected = () => {
        onSelected === null || onSelected === void 0 ? void 0 : onSelected(data);
    };
    const _onDeselected = () => {
        onDeselected === null || onDeselected === void 0 ? void 0 : onDeselected(data);
    };
    return (react.createElement("div", { className: classnames_default()(QuickFilterPillStyles.container, isSelected && QuickFilterPillStyles.selected, isSelected && selectedClassName, isMobile ? QuickFilterPillStyles.mobile : QuickFilterPillStyles.desktop, isLoading && QuickFilterPillStyles.loading, className), onClick: isSelected ? _onDeselected : _onSelected }, !isLoading ? (react.createElement(react.Fragment, null,
        " ",
        prefix && (react.createElement("span", { className: classnames_default()(QuickFilterPillStyles.prefix, prefixClassName) }, prefix)),
        text && react.createElement("span", { className: "quickFilterPill__text" }, text),
        suffix && (react.createElement("span", { className: classnames_default()(QuickFilterPillStyles.suffix, suffixClassName) }, suffix)))) : (react.createElement(Skeleton["default"], { width: "100px", type: "pill" }))));
}


//# sourceMappingURL=QuickFilterPill.js.map


/***/ }),

/***/ 53679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ResponsiveContainer; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.module.scss.js


var css_248z = ".ResponsiveContainer-module_container_box__vbXde {\n  display: flex;\n  flex-wrap: wrap;\n}";
var Styles = {"container_box":"ResponsiveContainer-module_container_box__vbXde"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=ResponsiveContainer.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.js





const ResponsiveContainer = (_a) => {
    var { className, id } = _a, props = (0,_tslib/* __rest */._)(_a, ["className", "id"]);
    return (react.createElement("div", { id: id, className: classnames_default()(Styles.container_box, className) }, props.children));
};


//# sourceMappingURL=ResponsiveContainer.js.map


/***/ }),

/***/ 12658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ScrollableContainer; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/scrollable-container/ScrollableContainer.module.scss.js


var css_248z = ".ScrollableContainer-module_main__XDkQb {\n  position: relative;\n}\n\n.ScrollableContainer-module_row__8pUP5 {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  overflow-x: scroll;\n  -ms-overflow-style: none; /* for Internet Explorer, Edge */\n  scrollbar-width: none; /* for Firefox */\n  overflow-y: scroll;\n  scroll-behavior: smooth;\n}\n\n.ScrollableContainer-module_row__8pUP5 > div:nth-last-child(1) > div {\n  margin-right: 0 !important;\n}\n\n.ScrollableContainer-module_next__XVi8F,\n.ScrollableContainer-module_prev__hUr-3 {\n  background-color: #08123b;\n  border-radius: 50%;\n}\n\n.ScrollableContainer-module_next__XVi8F {\n  position: absolute;\n  top: 40%;\n  right: 0;\n  z-index: 5;\n  cursor: pointer;\n  overflow: hidden;\n}\n.ScrollableContainer-module_next__XVi8F svg {\n  position: absolute;\n  margin: auto;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 6px;\n  height: 16px;\n}\n\n.ScrollableContainer-module_prev__hUr-3 {\n  position: absolute;\n  top: 40%;\n  left: 0;\n  z-index: 5;\n  cursor: pointer;\n  overflow: hidden;\n}\n.ScrollableContainer-module_prev__hUr-3 svg {\n  position: absolute;\n  margin: auto;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 6px;\n  height: 16px;\n  transform: rotate(180deg);\n}\n\n.ScrollableContainer-module_prvNavShadow__TfDPD,\n.ScrollableContainer-module_nextNavShadow__FTUDc {\n  width: 140px;\n  height: 100%;\n  display: block;\n  position: absolute;\n  top: 0;\n  -webkit-box-shadow: inset -140px 0px 60px -65px rgb(255, 255, 255);\n  -moz-box-shadow: inset -140px 0px 60px -65px rgb(255, 255, 255);\n  box-shadow: inset -140px 0px 60px -65px rgb(255, 255, 255);\n}\n\n.ScrollableContainer-module_nextNavShadow__FTUDc {\n  right: 0;\n}\n\n.ScrollableContainer-module_prvNavShadow__TfDPD {\n  left: 0;\n  transform: rotate(-180deg);\n}\n\n.ScrollableContainer-module_row__8pUP5::-webkit-scrollbar {\n  display: none; /* for Chrome, Safari, and Opera */\n}\n\n@media (max-width: 991px) {\n  .ScrollableContainer-module_next__XVi8F,\n  .ScrollableContainer-module_prev__hUr-3 {\n    width: 24px;\n    height: 24px;\n  }\n  .ScrollableContainer-module_next__XVi8F svg,\n  .ScrollableContainer-module_prev__hUr-3 svg {\n    width: 10px;\n    height: 10px;\n  }\n  .ScrollableContainer-module_next__XVi8F {\n    right: -9px;\n  }\n  .ScrollableContainer-module_prev__hUr-3 {\n    left: -9px;\n  }\n  .ScrollableContainer-module_prvNavShadow__TfDPD,\n  .ScrollableContainer-module_nextNavShadow__FTUDc {\n    display: none;\n  }\n}\n@media (min-width: 992px) {\n  .ScrollableContainer-module_next__XVi8F,\n  .ScrollableContainer-module_prev__hUr-3 {\n    width: 36px;\n    height: 36px;\n  }\n  .ScrollableContainer-module_next__XVi8F {\n    right: -20px;\n  }\n  .ScrollableContainer-module_prev__hUr-3 {\n    left: -20px;\n  }\n}";
var Styles = {"main":"ScrollableContainer-module_main__XDkQb","row":"ScrollableContainer-module_row__8pUP5","next":"ScrollableContainer-module_next__XVi8F","prev":"ScrollableContainer-module_prev__hUr-3","prvNavShadow":"ScrollableContainer-module_prvNavShadow__TfDPD","nextNavShadow":"ScrollableContainer-module_nextNavShadow__FTUDc"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=ScrollableContainer.module.scss.js.map

// EXTERNAL MODULE: ../core/dist/hooks/useIntersect.js
var useIntersect = __webpack_require__(86369);
;// CONCATENATED MODULE: ../core/dist/icons/nf_angleRightWhite.svg.js


var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgNfAngleRightWhite(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 4 8"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M.117.757A.48.48 0 01.116.13.368.368 0 01.633.086L.678.13l3.205 3.557a.481.481 0 01.039.578l-.039.05L.678 7.87a.37.37 0 01-.562-.001.483.483 0 01-.038-.577l.039-.05L3.039 4 .117.757z"
  })));
}


//# sourceMappingURL=nf_angleRightWhite.svg.js.map

;// CONCATENATED MODULE: ../core/dist/components/scrollable-container/ScrollableContainer.js






const ScrollableContainer = ({ children, containerClass, rowClass, nextArrowClass, prvArrowClass, nextNavShadowClass, prvNavShadowClass, scrollBy, isShow, items, fallback, length, autoScroll, fetchMoreItems, hasMoreItems, isNavShadow = true, showNavArrows = true, itemWrapperClass }) => {
    /***
     * Refs
     */
    const elmRef = (0,react.useRef)(null);
    const tempRef = (0,react.useRef)(null);
    /***
     * States
     */
    const [prvShow, setPrvShow] = (0,react.useState)(false);
    const [nextShow, setNextShow] = (0,react.useState)(false);
    const [scrollByitemWidth, setScrollByitemWidth] = (0,react.useState)(0);
    /***
     * Hooks
     */
    const { entry: rowSectionObj, setNode: rowRef } = (0,useIntersect/* useIntersect */.U)({
        threshold: 1
    });
    const { entry: firstInterSectionObj, setNode: firstElmRef } = (0,useIntersect/* useIntersect */.U)({
        threshold: 0.9
    });
    const { entry: lastInterSectionObj, setNode: lastElmRef } = (0,useIntersect/* useIntersect */.U)({
        threshold: 0.9
    });
    /***
     * Effects
     */
    (0,react.useEffect)(() => {
        if (scrollByitemWidth) {
            scrollHorizontal(scrollByitemWidth);
        }
    }, [scrollByitemWidth]);
    (0,react.useEffect)(() => {
        if ((lastInterSectionObj === null || lastInterSectionObj === void 0 ? void 0 : lastInterSectionObj.intersectionRatio) < 0.9 &&
            (rowSectionObj === null || rowSectionObj === void 0 ? void 0 : rowSectionObj.intersectionRatio) === 1) {
            setNextShow(true);
        }
        else {
            setNextShow(false);
            if (hasMoreItems) {
                fetchMoreItems === null || fetchMoreItems === void 0 ? void 0 : fetchMoreItems();
            }
        }
        return () => {
            setNextShow(false);
        };
    }, [lastInterSectionObj, length, rowSectionObj]);
    (0,react.useEffect)(() => {
        if ((firstInterSectionObj === null || firstInterSectionObj === void 0 ? void 0 : firstInterSectionObj.intersectionRatio) < 0.9 &&
            (rowSectionObj === null || rowSectionObj === void 0 ? void 0 : rowSectionObj.intersectionRatio) === 1) {
            setPrvShow(true);
        }
        else {
            if ((items === null || items === void 0 ? void 0 : items.length) === 1) {
                setNextShow(false);
            }
            setPrvShow(false);
        }
        return () => {
            setPrvShow(false);
        };
    }, [firstInterSectionObj, length, rowSectionObj]);
    /**
     * Handler Functions
     */
    const handlePrvArrow = () => {
        setScrollByitemWidth(tempRef.current.offsetWidth * scrollBy * -1);
    };
    const handleNextArrow = () => {
        setScrollByitemWidth(tempRef.current.offsetWidth * scrollBy);
    };
    const scrollHorizontal = (scrollOffset) => {
        elmRef.current.scrollLeft += scrollOffset;
        setScrollByitemWidth(0);
    };
    //AutoScroll
    (0,react.useEffect)(() => {
        if (autoScroll === "SCROLL_LR") {
            setScrollByitemWidth(tempRef.current.offsetWidth * length);
        }
    }, []);
    (0,react.useEffect)(() => {
        if ((rowSectionObj === null || rowSectionObj === void 0 ? void 0 : rowSectionObj.intersectionRatio) === 1 &&
            (autoScroll === "SCROLL_RL" || autoScroll === "SCROLL_LR")) {
            const interval = setInterval(() => {
                if (autoScroll === "SCROLL_RL") {
                    if ((lastInterSectionObj === null || lastInterSectionObj === void 0 ? void 0 : lastInterSectionObj.intersectionRatio) < 0.9) {
                        setScrollByitemWidth(tempRef.current.offsetWidth * scrollBy);
                    }
                    else {
                        setScrollByitemWidth(tempRef.current.offsetWidth * length * -1);
                    }
                }
                else if (autoScroll === "SCROLL_LR") {
                    if ((firstInterSectionObj === null || firstInterSectionObj === void 0 ? void 0 : firstInterSectionObj.intersectionRatio) < 0.9) {
                        setScrollByitemWidth(tempRef.current.offsetWidth * scrollBy * -1);
                    }
                    else {
                        setScrollByitemWidth(tempRef.current.offsetWidth * length);
                    }
                }
            }, 3000);
            return () => {
                clearInterval(interval);
            };
        }
    }, [rowSectionObj, firstInterSectionObj, lastInterSectionObj, scrollByitemWidth]);
    return (react.createElement("div", { className: classnames_default()(Styles.main, containerClass, prvShow ? isShow : "") },
        ((items === null || items === void 0 ? void 0 : items.length) || children) && (react.createElement(react.Fragment, null,
            react.createElement("div", { ref: rowRef },
                react.createElement("div", { ref: elmRef, className: classnames_default()(Styles.row, rowClass) }, items === null || items === void 0 ? void 0 :
                    items.map((item, index) => (react.createElement("div", { className: classnames_default()(itemWrapperClass), ref: index === 0 ? firstElmRef : index === items.length - 1 ? lastElmRef : tempRef, key: index }, item))),
                    children)),
            showNavArrows && prvShow && (react.createElement(react.Fragment, null,
                react.createElement("span", { className: classnames_default()(Styles.prev, prvArrowClass), onClick: handlePrvArrow },
                    react.createElement(SvgNfAngleRightWhite, null)),
                isNavShadow && (react.createElement("span", { className: classnames_default()(Styles.prvNavShadow, prvNavShadowClass) })))),
            showNavArrows && nextShow && (react.createElement(react.Fragment, null,
                react.createElement("span", { className: classnames_default()(Styles.next, nextArrowClass), onClick: handleNextArrow },
                    react.createElement(SvgNfAngleRightWhite, null)),
                isNavShadow && (react.createElement("span", { className: classnames_default()(Styles.nextNavShadow, nextNavShadowClass) })))))),
        fallback));
};


//# sourceMappingURL=ScrollableContainer.js.map


/***/ })

}]);